import { IconAlarm } from '@assets/images/main/index';
import {
  CameraFunctions1D,
  CameraFunctions1M,
  CameraFunctions1T,
  CameraFunctions2D,
  CameraFunctions2M,
  CameraFunctions2T,
  CameraFunctions3D,
  CameraFunctions3M,
  CameraFunctions3T,
  CameraFunctions4D,
  CameraFunctions4M,
  CameraFunctions4T,
  CameraFunctions5D,
  CameraFunctions5M,
  CameraFunctions5T,
  CameraFunctions6D,
  CameraFunctions6M,
  CameraFunctions6T,
  CameraFunctions7D,
  CameraFunctions7M,
  CameraFunctions7T,
} from '@assets/images/main/camera/main/functions';
import { IconEdgeOff, IconEdgeOn, IconOsOff, IconOsOn, IconServerOff, IconServerOn } from '@assets/images/main/icon';
import {
  cameraBannerBg,
  cameraBannerProduct,
  cameraScreenshot1D,
  cameraScreenshot1M,
  cameraScreenshot1T,
  cameraScreenshot2D,
  cameraScreenshot2M,
  cameraScreenshot2T,
  cameraScreenshot3D,
  cameraScreenshot3M,
  cameraScreenshot3T,
} from '@assets/images/main/camera';
import { IconBlueCircle, IconBlueShield } from '@assets/images/main/icon/blue';
import { Icon3d3d, Icon3dCycle, Icon3dDetect, Icon3dMeter } from '@assets/images/icon';
import { screenViewCamera1, screenViewCamera2, screenViewCamera3, screenViewCamera4, screenViewCamera5 } from '@assets/images/main/screenView';

import { ReactComponent as SvgGridLine } from '@assets/images/icon/svg/grid-line.svg';
import { ReactComponent as SvgLocationLine } from '@assets/images/icon/svg/location-line.svg';
import { ReactComponent as SvgChartLine } from '@assets/images/icon/svg/chart-line.svg';
import { ReactComponent as SvgPencilLine } from '@assets/images/icon/svg/pencil-line.svg';
import { ReactComponent as SvgAi } from '@assets/images/icon/svg/ai.svg';

export default {
  mainPage: {
    product: {
      title: '製品構成を見る',
      desc: '革新的な映像位置追跡システムをご紹介します。',
      outdoor: {
        title: '屋外カメラ',
        desc: 'カメラ映像を通じて、人・車両などさまざまな対象の<br/>位置や異常行動を検知・管理できます。',
      },
      indoor: {
        title: '屋内カメラ',
        desc: 'カメラ映像を用いて、<br/>屋内での人の動線を分析できます。',
      },
    },
  },

  banner: {
    title: '映像だけでリアルタイム位置追跡、<br/>人と車両の動きを自動で追跡します。',
    desc: 'AI ServerやAI Edgeを活用して、人・車両などの位置を<br/>簡単に追跡し、ORBRO OSと完全連携しましょう。',

    schemeTitle: 'ORBROが提案するカメラシステム',
    schemeDesc: '導入に関してご相談が必要ですか？',
    schemeDesc2: 'までご連絡ください。<br/>出入口管理の専門家がご案内いたします。',
    phone: '1522-9928',

    bgImg: cameraBannerBg,
    productImg: cameraBannerProduct,
  },

  bannerData: [
    {
      icon: IconEdgeOn,
      iconInv: IconEdgeOff,
      image: '',
      iconText: 'ORBRO Edge AI',
      sub: 'New',
      link: '/jp/camera/edge',
    },
    {
      icon: IconServerOn,
      iconInv: IconServerOff,
      image: '',
      iconText: 'ORBRO AI Server',
      sub: 'New',
      link: '/jp/camera/server',
    },
  ],
  screenView: {
    title: 'リアルタイム映像から得られる瞬間のインサイト',
    data: [
      { icon: SvgGridLine, text: 'マルチ映像ストリーミング', img: screenViewCamera1 },
      { icon: SvgLocationLine, text: '位置情報変換', img: screenViewCamera2 },
      { icon: SvgChartLine, text: 'ビデオインサイト', img: screenViewCamera3 },
      { icon: SvgPencilLine, text: 'プロンプト機能サポート', img: screenViewCamera4 },
      { icon: SvgAi, text: '状況認識エンジン', img: screenViewCamera5 },
    ],
  },
  screenShot: [
    {
      title: 'タグ不要、映像だけで位置追跡',
      desc: '人物や車両がカメラに捉えられると、<br/>その位置が地図上にリアルタイムで表示されます。タグを使わず、映像ベースで動きを認識し、図面上で位置を直感的に確認できます。',
      img: {
        desktop: cameraScreenshot1D,
        tablet: cameraScreenshot1T,
        mobile: cameraScreenshot1M,
      },
    },
    {
      title: '新たにカメラを設置する必要はありません',
      desc: 'RTSPやONVIF対応の既存CCTVで、<br/>すぐにAI映像位置追跡を導入できます。設定も簡単で、カメラごとの認識モデルも自由に変更可能です。',
      img: {
        desktop: cameraScreenshot2D,
        tablet: cameraScreenshot2T,
        mobile: cameraScreenshot2M,
      },
    },
    {
      title: 'AIが現場の「行動」を読み解いて通知します',
      desc: 'AIが現場の状況を理解し、解釈した情報を提供します。<br/>危険の検知、作業状況の把握、出入り管理など、多様な場面で活用できます。',
      img: {
        desktop: cameraScreenshot3D,
        tablet: cameraScreenshot3T,
        mobile: cameraScreenshot3M,
      },
    },
  ],

  video: {
    title: 'ORBRO AIカメラシステム',
    desc: [
      { text: '屋外にいる人や車両の位置情報を収集・分析します。' },
      { text: '屋内空間で移動している人の位置を把握します。' },
      { text: '既存のCCTVなど既存映像インフラとの連携が可能です。' },
      { text: '必要なカメラ機器を簡単に追加できます。' },
    ],
  },

  func: {
    title: 'カメラ機能を確認する',
    desc: 'カメラの多様な機能をチェックしてみましょう。',

    data: [
      {
        img: IconBlueShield,
        title: '権限とグループ管理',
        desc: '管理者/ユーザーの権限を分けて、それぞれに機能のアクセス権を設定できます。\n部署やチーム単位でグループを構成することも可能です。',
      },
      {
        img: IconAlarm,
        title: '条件付きアラート設定（5段階）',
        desc: '指定条件に基づき、5段階のアラートを設定可能。\n異常をすばやく検知して対応を支援します。',
      },
      {
        img: Icon3dMeter,
        title: 'ゾーンモニタリング',
        desc: '地図上にゾーンを設定し、該当エリアに入った人や資産をリアルタイムでモニタリングします。',
      },
      {
        img: Icon3dCycle,
        title: '逆走検知',
        desc: '進行方向と反対の動きをシステムが自動検出し、警告を発します。',
      },
      {
        img: Icon3dDetect,
        title: '入退場検知（In/Out Zone）',
        desc: '出入口における入退場を自動認識し、記録や滞在時間の分析も可能です。',
      },
      {
        img: Icon3d3d,
        title: '機器検索と状態管理',
        desc: '多数のタグやアンカー機器の検索、バッテリー・接続状態を一目で把握できます。',
      },
    ],
  },

  functions: {
    title: 'AI技術を活用したデジタルツイン位置追跡',
    desc: 'ORBROのAIカメラシステムは高精度かつ高信頼性を誇ります。<br/>屋内外の人・車両の位置を把握・分析し、有用なデータを提供します。',

    line: 3,
    card: [
      {
        size: '3',
        tag: '主要機能',
        title: '映像で検知した物体を<br/>地図上にリアルタイム表示',
        label: '管理者向け',
        img: {
          desktop: CameraFunctions1D,
          tablet: CameraFunctions1T,
          mobile: CameraFunctions1M,
        },
      },
      {
        color: '#fff',
        size: '1',
        tag: 'モバイル対応',
        title: 'すべての空間で、<br/>モバイル対応可能',
        label: '共通機能',
        img: {
          desktop: CameraFunctions2D,
          tablet: CameraFunctions2T,
          mobile: CameraFunctions2M,
        },
      },
      {
        size: '2',
        tag: '既存CCTVとの互換',
        title: 'すべての映像情報と<br/>完全互換',
        label: '管理者向け',
        img: {
          desktop: CameraFunctions3D,
          tablet: CameraFunctions3T,
          mobile: CameraFunctions3M,
        },
      },
      {
        size: '2',
        tag: '人物・車両検出',
        title: '人物・車両の検出が可能、<br/>高い認識率',
        label: '管理者向け',
        img: {
          desktop: CameraFunctions4D,
          tablet: CameraFunctions4T,
          mobile: CameraFunctions4M,
        },
      },
      {
        size: '2',
        tag: 'オンプレミス構築',
        title: '最も確実で<br/>安定したセキュリティ体制',
        label: 'オンプレミス',
        img: {
          desktop: CameraFunctions5D,
          tablet: CameraFunctions5T,
          mobile: CameraFunctions5M,
        },
      },
      {
        size: '1',
        tag: '大規模駐車場など',
        title: '大規模駐車場にも<br/>適用可能な設置',
        label: 'エンタープライズ',
        img: {
          desktop: CameraFunctions6D,
          tablet: CameraFunctions6T,
          mobile: CameraFunctions6M,
        },
      },
      {
        size: '3',
        tag: 'ダッシュボード',
        title: 'データインサイト、<br/>データ駆動型の意思決定',
        label: '管理者向け',
        img: {
          desktop: CameraFunctions7D,
          tablet: CameraFunctions7T,
          mobile: CameraFunctions7M,
        },
      },
    ],
  },

  FAQ: [
    {
      title: 'ORBROの映像位置追跡システムはどのように動作しますか？',
      description:
        '設置されたカメラが映像を収集し、AIが人物や車両をリアルタイムで認識し、位置を計算します。<br/>計算された位置情報は ORBRO OS 上でマップ表示されます。',
    },
    {
      title: 'ORBRO Edge AI と AI Server の違いは何ですか？',
      description:
        'ORBRO Edge AI はAI分析と位置計算を1台で完結する独立型装置です。<br/>一方、AI Server は複数のカメラ映像を統合分析し、ORBRO Serverと連携して動作します。',
    },
    {
      title: '既存のCCTVカメラと連携可能ですか？',
      description: 'はい。RTSPやONVIFプロトコル対応カメラであれば連携可能です。',
    },
    {
      title: 'サーバーがなくても利用できますか？',
      description: 'ORBRO Edge AI はサーバーなしでも動作可能です。<br/>ただし、AI Server は ORBRO Server とセットで使用する必要があります。',
    },
    {
      title: '映像ベースの位置追跡はBLE/UWBより優れていますか？',
      description:
        '用途によります。<br/>映像方式はタグ不要ですが視野制限があり、<br/>無線方式はタグが必要ですが視野に依存しません。<br/>ORBROは両方式を併用可能です。',
    },
    {
      title: '映像データは保存されますか？プライバシーは守られますか？',
      description:
        '基本的にAIは映像を解析するだけで、映像自体は保存しません。<br/>位置情報のみが記録されます。保存が必要な場合でも暗号化やアクセス制御が可能です。',
    },
    {
      title: '人物以外の検出も可能ですか？',
      description: 'デフォルトでは人物を対象としていますが、車両、設備、安全装備（ヘルメット等）の検出も設定で可能です。',
    },
    {
      title: 'リアルタイム通知を受け取ることはできますか？',
      description: 'はい、可能です。<br/>ゾーンへの進入や未検出などの条件に応じて、Push通知・メール・Webhookなどでリアルタイム通知を送信できます。',
    },
  ],
};
